module.exports = __webpack_public_path__ + "static/Dropshadow-AY-92b1f94d602f026eecb825654861aaab.png";